<script>
import moment from "moment";
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { exportLead } from '@/utils/lead';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
// import { getBranches } from '@/utils/branch';
import DateRangePicker from "daterangepicker";
import { changeLeadStage } from '@/utils/lead';
import Permissions from '@/utils/permissions.js';
import { leadImportConfig } from '@/utils/admin';
import { createSiteInspection } from '@/utils/site-inspection';
import { useLeadMetaStore } from '@/stores/useLeadMetaStore';
import BusinessCardScanModal from '@/views/pages/crm/business-cards/business-card-scan-modal.vue';

export default {
  components: { BusinessCardScanModal },
  inject: ['setLoading'],
  data() {
    return {
      loading: true,
      tableColumns: [
        { key: 'checkbox', label: '', width: '40px' },
        { key: 'name', label: 'Name' },
        { key: 'email', label: 'Email' },
        { key: 'mobile', label: 'Mobile' },
        { key: 'assigned', label: 'Assigned' },
        { key: 'stage', label: 'Stage' },
        { key: 'source', label: 'Source' },
        { key: 'created_at', label: 'Created' },
        { key: 'actions', label: 'Actions' },
      ],
      title: "CRM",
      text: "CRM",
      user: '',
      stage: '',
      source: '',
      from_date: '',
      to_date: '',
      branch_id: '',
      search_keyword: '',
      data: [],
      // users: [],
      // stages: [],
      // sources: [],
      // branches: [],
      selected_rows: [],
      import_configs: [],
      pagination: {
        current_page: 1,
        per_page: 25,
        last_page: 1,
        total: 0,
        links: []
      },
      conversion: '',
      dateRangeTimeout: null,
      searchTimeout: null,  
      permissions: Permissions,
      is_activity_filter: false,
      is_reminder_filter: false,
      is_junk_filter: false,      
      junkPopoverLeadId: null,        
      client_type: 'App\\Models\\Lead'
    };
  },

  // computed: {
  //   //  serialNo() {
  //   //   return (this.pagination.current_page - 1) * this.pagination.per_page;
  //   //  },
  //   text1() {
  //     return `Leads (${this.$numFormat(this.pagination.total)})`;
  //   },
  //   allSelected() {
  //     return this.data?.length && this.selected_rows.length === this.data.length;
  //   }
  // },

  computed: {
  branches() { return useLeadMetaStore().branches || [] },
  stages()   { return useLeadMetaStore().stages || [] },
  sources()  { return useLeadMetaStore().sources || [] },
  users()    { return useLeadMetaStore().users || [] },
  text1() {
    return `Leads (${this.$numFormat(this.pagination.total)})`;
  },
  allSelected() {
    return this.data?.length && this.selected_rows.length === this.data.length;
  }
},

  async mounted() {
    await Permissions.init();
    // Initialize filters from query parameters
    this.user = this.$route.query.user_id || '';
    this.conversion = this.$route.query.conversion || '';
    this.branch_id = this.$route.query.branch_id || '';
    this.stage = this.$route.query.lead_stage_id || '';
    this.source = this.$route.query.lead_source_id || '';
    this.search_keyword = this.$route.query.search || '';

    // No date filter by default
    this.from_date = '';
    this.to_date = '';

    // this.leads();
    // this.getUsers();
    // this.getStages();
    // this.getSources();
    // this.allBranches();
    this.leads();
    this.loadMeta();
    if (this.auth.type === 'ADMIN') {
      this.importConfig();
    }

    const start = moment().subtract(29, "days");
    const end = moment();

    const picker = new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        autoUpdateInput: false,
        locale: {
          format: "DD/MM/YYYY",
          separator: " - ",
          cancelLabel: "Clear"
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
        this.setDateRange(start, end);
        this.$refs.dateRangeInput.value = `${start.format("DD/MM/YYYY")} - ${end.format("DD/MM/YYYY")}`;
      },
      this.booking_range
    );

    // Clear input on cancel
    if (picker && picker.container) {
      picker.container.on('click', '.cancel', () => {
        this.from_date = '';
        this.to_date = '';
        this.$refs.dateRangeInput.value = '';
        this.leads();
      });
    }
  },

  methods: {

    onCardScanned(data) {
  this.$refs.leadModal.add();
  this.$refs.leadModal.prefill(data);
  Modal.getOrCreateInstance(document.getElementById('lead_modal')).show();
},

    debouncedSearch() {
  clearTimeout(this.searchTimeout);
  this.searchTimeout = setTimeout(() => {
    this.leads();
  }, 500);   
},

  async createSiteInspection(leadId) {
    this.setLoading(true)
    try {
        const res = await createSiteInspection({
            party_type: 'App\\Models\\Lead',
            party_id: leadId
        })
        this.$swalToast(res.data.message)
    } catch (error) {
        if (error.type === 'validation') {
            const firstError = Object.values(error.errors)[0]
            this.$swalToast(firstError[0], 'error')
        } else {
            this.$swalToast(error.message, 'error')
        }
    } finally {
        this.setLoading(false)
    }
},

    booking_range(start, end) {
      return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
      if (this.dateRangeTimeout) {
        clearTimeout(this.dateRangeTimeout);
      }

      this.from_date = start.format("YYYY-MM-DD");
      this.to_date = end.format("YYYY-MM-DD");

      this.dateRangeTimeout = setTimeout(() => {
        this.leads();
      }, 300);
    },

    async loadMeta() {
      await useLeadMetaStore().loadAll()
    },


    // async allBranches() {
    //   this.branches = await getBranches();
    // },

    handleToggleAll(event) {
      if (event.target.checked) {
        this.selected_rows = this.data.filter(row => row.converted_at === null).map(row => row.id);
      } else {
        this.selected_rows = [];
      }
    },

    // async getStages() {
    //   //  this.setLoading(true);
    //   try {
    //     const response = await axios.get('/lead-stages');
    //     this.stages = response.data.data;
    //   } catch (error) {
    //     this.$swalToast(error.message, 'error');
    //   } finally {
    //     this.setLoading(false);
    //   }
    // },

    // async getSources() {
    //   // this.setLoading(true);
    //   try {
    //     const response = await axios.get('/lead-sources');
    //     this.sources = response.data.data;
    //   } catch (error) {
    //     this.$swalToast(error.message, 'error');
    //   } finally {
    //     this.setLoading(false);
    //   }
    // },

    // async getUsers() {
    //   //  this.setLoading(true);
    //   try {
    //     const response = await axios.get('/users/all-users');
    //     this.users = response.data.data;
    //   } catch (error) {
    //     this.$swalToast(error.message, 'error');
    //   } finally {
    //     this.setLoading(false);
    //   }
    // },

    async leads(page = 1) {
      this.loading = true;
      //  this.setLoading(true);
      try {
        const params = {
          page: page,
          user_id: this.user || '',
          from_date: this.from_date || '',
          to_date: this.to_date || '',
          branch_id: this.branch_id || '',
          lead_stage_id: this.stage || '',
          lead_source_id: this.source || '',
          conversion: this.conversion,
          per_page: this.pagination.per_page,
          is_activity_filter: this.is_activity_filter,
          is_reminder_filter: this.is_reminder_filter,
          is_junk_filter: this.is_junk_filter,
          search_keyword: this.search_keyword.trim() || ''
        };
        const query_string = new URLSearchParams(params).toString();
        const response = await axios.get(`/leads?${query_string}`);
        this.data = response.data.data.data;
        this.pagination = {
          current_page: response.data.data.current_page,
          per_page: response.data.data.per_page,
          last_page: response.data.data.last_page,
          total: response.data.data.total,
          links: response.data.data.links
        };
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.loading = false;
        // this.setLoading(false);
      }
    },

    // changePage(url){
    //  if (!url) return;
    //  const page = new URL(url).searchParams.get("page");
    //  this.leads(page);
    // },

    async changeStage(lead_id, stage_id) {
      this.setLoading(true);
      try {
        const response = await changeLeadStage(lead_id, stage_id);
        this.$swalToast(response.data.message);
        this.leads();
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },

    async importConfig() {
      this.setLoading(true);
      try {
        const response = await leadImportConfig();
        this.import_configs = response.data.data;
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },

    async exportFile(format) {
      await exportLead({
        format,
        to_date: this.to_date,
        from_date: this.from_date,
        ids: this.selected_rows,
        setLoading: this.setLoading,
        toastError: (msg) => this.$swalToast(msg, 'error'),
        timeStamp: () => this.$timeStamp(),
      });
    },

    bulkAction() {
      if (this.selected_rows.length) {
        this.$refs.leadModal.bulkAction(this.selected_rows);
        const modalEl = document.getElementById("bulk_action_lead");
        let modal = Modal.getInstance(modalEl);
        if (!modal) { modal = new Modal(modalEl); }
        modal.show();
      } else {
        this.$swalToast("Please select at least one option.", 'warning');
      }
    },

    clearFilter() {
      this.user = '';
      this.stage = '';
      this.source = '';
      this.branch_id = '';
      this.from_date = '';
      this.to_date = '';
      this.conversion = '';
      this.search_keyword = '';
      this.is_activity_filter = false;
      this.is_reminder_filter = false;
      this.is_junk_filter = false;
      if (this.$refs.dateRangeInput) {
        this.$refs.dateRangeInput.value = '';
      }
      this.leads();
    },

   
formatSingleReason(reason) {
  if (!reason) return '';
  return reason.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
},


junkGaugeStyle(score) {
  const max = 5; 
  const pct = Math.min((score / max) * 100, 100);
  let color = '#facc15';
  if (score >= 4) color = '#dc2626';     
  else if (score >= 2) color = '#f59e0b'; 
  return {
    background: `conic-gradient(${color} ${pct}%, #e5e7eb ${pct}% 100%)`
  };
},

toggleJunkPopover(leadId) {
  this.junkPopoverLeadId = this.junkPopoverLeadId === leadId ? null : leadId;
},
  },
};
</script>

<style scoped>

.dropdown-btn-size {
  font-size: 12px !important;
}
/* ── LEAD NAME LINK ── */
.lead-name-link {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  text-decoration: none;
  transition: color .15s;
}

.lead-name-link:hover {
  color: #6366f1;
}

/* ── AVATAR ── */
.l-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
}

/* ── META (email / phone) ── */
.l-meta {
  font-size: 12px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 5px;
}

.l-meta i {
  font-size: 13px;
  flex-shrink: 0;
}

/* ── ASSIGNED USER ── */
.l-assigned {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #1e293b;
}

.l-assigned img {
  border-radius: 50%;
  width: 22px;
  height: 22px;
  object-fit: cover;
}

/* ── SOURCE BADGE ── */
.l-source-badge {
  font-size: 10.5px;
  color: #475569;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 2px 10px;
  display: inline-block;
  font-weight: 500;
}

/* ── DATE TEXT ── */
.l-date {
  font-size: 11.5px;
  color: #94a3b8;
}

/* ── FILTER BAR ── */
.l-filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.l-filter-select {
  height: 36px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 12.5px;
  color: #1e293b;
  background: #fff;
  outline: none;
  cursor: pointer;
  transition: border-color .15s;
  min-width: 120px;
}

.l-filter-select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, .1);
}

.l-search-wrap {
  display: flex;
  align-items: center;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.l-search-wrap:focus-within {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, .1);
}

.l-search-input {
  border: none;
  outline: none;
  height: 34px;
  padding: 0 10px;
  font-size: 12.5px;
  color: #1e293b;
  width: 180px;
  background: transparent;
}

.l-date-input {
  height: 36px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 12.5px;
  color: #1e293b;
  background: #fff;
  outline: none;
  width: 210px;
  transition: border-color .15s;
}

.l-date-input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, .1);
}

.l-clear-btn {
  width: 34px;
  height: 34px;
  background: #fff0f3;
  border: 1.5px solid #fecdd3;
  border-radius: 8px;
  color: #f43f5e;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .15s;
}

.l-clear-btn:hover {
  background: #f43f5e;
  color: #fff;
  border-color: #f43f5e;
}

/* checkbox filter labels */
.l-check-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #475569;
  cursor: pointer;
  white-space: nowrap;
}

/* vue-select in filter */
:deep(.l-vselect .vs__dropdown-toggle) {
  border: 1.5px solid #e2e8f0 !important;
  border-radius: 8px !important;
  min-height: 36px !important;
  padding: 0 8px !important;
  background: #fff !important;
}

:deep(.l-vselect .vs__dropdown-toggle:focus-within) {
  border-color: #6366f1 !important;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, .1) !important;
}

:deep(.l-vselect .vs__search) {
  font-size: 12.5px !important;
}

:deep(.l-vselect .vs__selected) {
  font-size: 12px !important;
  background: #eef2ff !important;
  border: 1px solid #c7d2fe !important;
  border-radius: 5px !important;
  color: #3730a3 !important;
}

/* ── CHIP TOGGLE FILTERS ── */
.l-chip-toggle {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 20px;
  padding: 6px 12px;
  cursor: pointer;
  transition: all .15s;
  white-space: nowrap;
}
.l-chip-toggle i { font-size: 13px; }
.l-chip-toggle:hover { border-color: #cbd5e1; background: #f8fafc; }
.l-chip-toggle.active { background: #eef2ff; border-color: #6366f1; color: #4338ca; }
.l-chip-junk.active { background: #fffbeb; border-color: #f59e0b; color: #b45309; }

/* ── MINI GAUGE (row badge) ── */
.l-junk-gauge {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: transform .15s;
}
.l-junk-gauge:hover { transform: scale(1.08); }

.l-junk-gauge-inner {
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9.5px;
  font-weight: 700;
  color: #b45309;
}

/* ── POPOVER CARD ── */
.l-junk-popover {
  position: absolute;
  top: 38px;
  left: 0;
  z-index: 50;
  width: 220px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, .12);
  padding: 16px;
}

.l-junk-popover-header {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}

/* ── BIG GAUGE (inside popover) ── */
.l-junk-gauge-big {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.l-junk-gauge-big-inner {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.l-junk-score-num {
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1;
}

.l-junk-score-label {
  font-size: 9px;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .4px;
  margin-top: 2px;
}

.l-junk-popover-title {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: .3px;
  margin-bottom: 8px;
  border-top: 1px solid #f1f5f9;
  padding-top: 10px;
}

.l-junk-reason-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #b45309;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 6px;
  padding: 5px 8px;
  margin-bottom: 6px;
}

.l-junk-reason-row i {
  font-size: 13px;
  color: #f59e0b;
  flex-shrink: 0;
}
</style>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">

      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">

          <!-- List / Grid toggle -->
          <!-- <div class="d-flex align-items-center border bg-white rounded p-1">
            <router-link to="/crm/leads-list" class="btn btn-icon btn-sm me-1" title="List View">
              <i class="ti ti-list-tree"></i>
            </router-link>
            <router-link to="/crm/leads-grid" class="btn btn-icon btn-sm" title="Grid View">
              <i class="ti ti-layout-grid"></i>
            </router-link>
          </div> -->

          <!-- Per Page -->
          <vue-select
            v-model="pagination.per_page"
            :options="[
              { label: '25', value: 25 },
              { label: '50', value: 50 },
              { label: '75', value: 75 },
              { label: '100', value: 100 },
            ]"
            label="label"
            :reduce="p => p.value"
            placeholder="Per Page"
            :clearable="false"
            @update:modelValue="leads()"
            style="min-width: 100px;"
          ></vue-select>

          <!-- Import -->
          <div v-if="auth.type === 'ADMIN'">
            <div class="dropdown">
              <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown">
                <i class="ti ti-file-import me-1"></i>Import
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <router-link to="/crm/leads/import/csv" class="dropdown-item rounded-1">
                    <i class="ti ti-file-type-csv me-1"></i>Import from CSV
                  </router-link>
                </li>
                <li v-for="(row, index) in import_configs" :key="index">
                  <router-link :to="`/crm/leads/import/${row.platform}`" class="dropdown-item rounded-1">
                    <i class="ti ti-file-import me-1"></i>Import from {{ row.platform }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <!-- Export -->
          <div v-if="data?.length">
            <div class="dropdown">
              <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown">
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile('csv')">
                    <i class="ti ti-file-type-csv me-1"></i>Export as CSV
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile('xlsx')">
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Bulk Actions -->
          <button type="button" class="btn btn-outline-secondary" @click="bulkAction">
            <i class="ti ti-playstation-square me-1"></i>Bulk Actions
          </button>

          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#scan_card_modal"
            class="btn btn-outline-primary d-flex align-items-center">
            <i class="ti ti-scan me-2"></i>Scan VCard
          </a>

          <!-- Add Lead -->
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#lead_modal"
            class="btn btn-primary d-flex align-items-center" @click="$refs.leadModal.add();">
            <i class="ti ti-circle-plus me-2"></i>Add Lead
          </a>

        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Main Card -->
      <div class="card border-0 shadow-sm mb-0" style="border-radius:14px;">

        <!-- Card Header — title + filters -->
        <div
          class="card-header bg-white border-bottom d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4">
          <h5 class="mb-0 fw-bold" style="font-size:14px; color:#0f172a;">
            Leads List
            <span style="font-size:11px; color:#94a3b8; font-weight:500; margin-left:6px;">({{
              $numFormat(pagination.total) }})</span>
            <!-- Clear filter -->
            <button
              v-if="search_keyword || stage || source || user || branch_id || from_date || to_date || conversion || is_reminder_filter || is_activity_filter || is_junk_filter"
              class="l-clear-btn ms-2" style="display:inline-flex; width:28px; height:28px; font-size:13px;"
              @click="clearFilter" title="Clear Filters">
              <i class="ti ti-filter-x"></i>
            </button>
          </h5>

          <!-- Filters -->
          <div class="l-filter-bar">

            <!-- Date Range -->
            <input type="text" class="l-date-input date-range bookingrange" ref="dateRangeInput"
              placeholder="dd/mm/yyyy - dd/mm/yyyy" />

            <!-- Branch -->
            <vue-select
              class="l-vselect"
              v-if="auth?.type === 'ADMIN'"
              v-model="branch_id"
              :options="branches"
              label="name"
              :reduce="r => r.id"
              placeholder="All Branches"
              :clearable="true"
              @update:modelValue="leads()"
              style="min-width: 150px;"
            ></vue-select>

            <!-- Conversion -->
            <vue-select
              class="l-vselect"
              v-model="conversion"
              :options="[
                { label: 'Converted', value: true },
                { label: 'Not Converted', value: false },
              ]"
              label="label"
              :reduce="c => c.value"
              placeholder="Conversion"
              :clearable="true"
              @update:modelValue="leads()"
              style="min-width: 150px;"
            ></vue-select>

            <!-- Stage -->
            <vue-select
              class="l-vselect"
              v-model="stage"
              :options="stages"
              label="name"
              :reduce="r => r.id"
              placeholder="All Stages"
              :clearable="true"
              @update:modelValue="leads()"
              style="min-width: 140px;"
            ></vue-select>

            <!-- Source -->
            <vue-select
              class="l-vselect"
              v-model="source"
              :options="sources"
              label="name"
              :reduce="r => r.id"
              placeholder="All Sources"
              :clearable="true"
              @update:modelValue="leads()"
              style="min-width: 140px;"
            ></vue-select>

            <!-- Users -->
            <div style="min-width:140px;">
              <vue-select class="l-vselect" :options="users" label="name" v-model="user" :reduce="u => u.id"
                placeholder="All Users" @update:modelValue="leads()" />
            </div>

            <!-- Search -->
            <div class="l-search-wrap">
              <input type="text" class="l-search-input" v-model="search_keyword" placeholder="Search leads..."
              @input="debouncedSearch" />
              <span style="padding:0 10px; color:#94a3b8;"><i class="ti ti-search"></i></span>
            </div>

            <!-- Reminder / Activity / Junk Toggles -->
            <div class="d-flex align-items-center gap-2">
              <button type="button" class="l-chip-toggle" :class="{ active: is_reminder_filter }"
                @click="is_reminder_filter = !is_reminder_filter; leads()">
                <i class="ti ti-bell"></i> Reminder
              </button>

              <button type="button" class="l-chip-toggle" :class="{ active: is_activity_filter }"
                @click="is_activity_filter = !is_activity_filter; leads()">
                <i class="ti ti-activity"></i> Activity
              </button>

              <button type="button" class="l-chip-toggle l-chip-junk" :class="{ active: is_junk_filter }"
                @click="is_junk_filter = !is_junk_filter; leads()">
                <i class="ti ti-alert-triangle"></i> Junk
              </button>
            </div>

          </div>
        </div>

        <!-- Card Body — Table -->
        <div class="card-body px-3 pt-2 pb-3" style="background:#f1f5f9;">

          <app-table :columns="tableColumns" :rows="data" :pagination="pagination" :loading="loading"
            :skeleton-rows="25" empty-text="No leads found." empty-icon="ti ti-users" @page-change="leads">

            <!-- Checkbox Header -->
            <template #header-checkbox>
              <div class="form-check form-checkbox-success mb-0">
                <input type="checkbox" class="form-check-input" :checked="allSelected" @change="handleToggleAll">
              </div>
            </template>

            <!-- Checkbox -->
            <template #checkbox="{ row }">
              <div class="form-check form-checkbox-success mb-0">
                <input type="checkbox" class="form-check-input" :value="row.id" v-model="selected_rows"
                  :disabled="row.converted_at !== null">
              </div>
            </template>

            <!-- Name -->
            <template #name="{ row }">
              <div class="d-flex align-items-center gap-2 position-relative">
                <div class="l-avatar" :style="{ background: `hsl(${((row.name || 'A').charCodeAt(0) * 37) % 360}, 60%, 55%)` }">
                  {{ (row.name || '').charAt(0).toUpperCase() }}
                </div>

                <router-link :to="{ name: 'leads-details', params: { id: row.id } }" class="lead-name-link">
                  {{ row.name }}
                </router-link>

                <!-- Junk mini gauge -->
                <div v-if="row.is_junk" class="l-junk-gauge" :style="junkGaugeStyle(row.junk_score)"
                  @click.stop="toggleJunkPopover(row.id)">
                  <div class="l-junk-gauge-inner">{{ row.junk_score }}</div>
                </div>

                <!-- Junk popover card -->
                <div v-if="junkPopoverLeadId === row.id" class="l-junk-popover" v-click-outside="() => junkPopoverLeadId = null">
                  <div class="l-junk-popover-header">
                    <div class="l-junk-gauge-big" :style="junkGaugeStyle(row.junk_score)">
                      <div class="l-junk-gauge-big-inner">
                        <span class="l-junk-score-num">{{ row.junk_score }}</span>
                        <span class="l-junk-score-label">Junk Score</span>
                      </div>
                    </div>
                  </div>
                  <div class="l-junk-popover-body">
                    <div class="l-junk-popover-title">Flagged Reasons</div>
                    <div v-for="(reason, idx) in row.junk_reasons" :key="idx" class="l-junk-reason-row">
                      <i class="ti ti-alert-circle"></i> {{ formatSingleReason(reason) }}
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- Email -->
            <template #email="{ row }">
              <span class="l-meta" v-if="row.email">
                <i class="ti ti-mail" style="color:#22c55e;"></i>
                {{ row.email }}
              </span>
              <span v-else style="font-size:11.5px; color:#cbd5e1; font-style:italic;">-</span>
            </template>

            <!-- Mobile -->
            <template #mobile="{ row }">
              <span class="l-meta">
                <i class="ti ti-phone" style="color:#6366f1;"></i>
                <router-link :to="{ name: 'leads-details', params: { id: row.id } }"
                  style="color:inherit; text-decoration:none;">
                  {{ row.mobile }}
                </router-link>
              </span>
            </template>

            <!-- Assigned -->
            <template #assigned="{ row }">
              <div class="l-assigned">
                <img v-if="row.user?.image_url" :src="row.user.image_url" width="22" />
                <span v-else class="l-avatar" style="width:22px;height:22px;font-size:10px;"
                  :style="{ background: `hsl(${((row.user?.name || 'A').charCodeAt(0) * 37) % 360}, 60%, 55%)` }">
                  {{ (row.user?.name || '').charAt(0).toUpperCase() }}
                </span>
                {{ row.user?.name }}
              </div>
            </template>

            <!-- Stage -->
            <template #stage="{ row }">
              <span class="badge bg-light border" :style="{ 'color': row?.stage?.color }" v-if="!row.converted_at">
                {{ row?.stage?.name }}
              </span>
              <span v-else class="badge bg-light text-success border" v-html="$leadConversionLabel()"
                :title="$formatDate(row.converted_at)">
              </span>
            </template>

            <!-- Source -->
            <template #source="{ row }">
              <span class="l-source-badge">{{ row.source?.name }}</span>
            </template>

            <!-- Created -->
            <template #created_at="{ row }">
              <span class="l-date">{{ $formatDate(row.created_at) }}</span>
            </template>

            <!-- Actions -->
            <template #actions="{ row }">
              <div class="dropdown" v-if="!row.converted_at">
                <button class="btn btn-icon btn-sm rounded-circle" type="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <i class="ti ti-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal"
                      data-bs-target="#lead_modal" @click="$refs.leadModal.editLead(row)">
                      <i class="ti ti-edit me-1"></i>Edit
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal"
                      data-bs-target="#notes_modal" @click="$refs.notesModal.addNote(row)">
                      <i class="ti ti-pencil-plus me-1"></i>Create Note
                    </a>
                  </li>
                  <li>
                    <hr class="dropdown-divider">
                  </li>
                  <li v-if="permissions.isLoaded && permissions.canCreateProposal">
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal"
                      data-bs-target="#proposal_modal" @click="$refs.proposalModal.createViaLead(row.id)">
                      <i class="ti ti-file-text me-1"></i>Create Proposal
                    </a>
                  </li>
                  <li v-if="permissions.isLoaded && permissions.canCreateQuotation">
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal"
                      data-bs-target="#quotation_modal"
                      @click="$refs.quotationModal.createViaParty(client_type, row.id)">
                      <i class="ti ti-file-check me-1"></i>Create Quotation
                    </a>
                  </li>
                  <li v-if="permissions.isLoaded && permissions.canCreateProforma">
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal"
                      data-bs-target="#proforma_invoice_modal"
                      @click="$refs.proformaInvoiceModal.createViaParty(client_type, row.id)">
                      <i class="ti ti-receipt-rupee me-1"></i>Create Proforma Invoice
                    </a>
                  </li>
                  <li v-if="permissions.isLoaded && permissions.canCreateSampling">
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal"
                      data-bs-target="#sampling_modal" @click="$refs.samplingModal.createViaParty(client_type, row.id)">
                      <i class="ti ti-receipt-rupee me-1"></i>Sampling Request
                    </a>
                  </li>
                  <li v-if="permissions.isLoaded && permissions.canCreateSalesOrder">
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal"
                      data-bs-target="#sales_order_modal"
                      @click="$refs.salesOrderModal.createViaParty(client_type, row.id)">
                      <i class="ti ti-receipt-rupee me-1"></i>Create Sales Order
                    </a>
                  </li>
                  <li v-if="permissions.isLoaded">
                      <a class="dropdown-item rounded-1" href="javascript:void(0);"
                          @click="createSiteInspection(row.id)">
                          <i class="ti ti-clipboard-check me-1"></i>Create Site Inspection
                      </a>
                  </li>
                  <li>
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal"
                      data-bs-target="#lead_conversion_modal" @click="$refs.leadModal.editLead(row)">
                      <i class="ti ti-user-shield me-1"></i>Mark as converted
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item rounded-1" href="javascript:void(0);" data-bs-toggle="modal"
                      data-bs-target="#delete_modal" @click="$refs.leadModal.editLead(row)">
                      <i class="ti ti-trash me-1"></i>Delete
                    </a>
                  </li>
                </ul>
              </div>
            </template>

          </app-table>

        </div>
      </div>
      <!-- /Main Card -->

    </div>

    <app-footer></app-footer>
  </div>

  <sampling-modal ref="samplingModal" @updated="leads"></sampling-modal>
  <proposal-modal ref="proposalModal"></proposal-modal>
  <quotation-modal ref="quotationModal"></quotation-modal>
  <leads-modal ref="leadModal" @updated="leads"></leads-modal>
  <proforma-invoice-modal ref="proformaInvoiceModal"></proforma-invoice-modal>
  <sales-order-modal ref="salesOrderModal" @updated="leads"></sales-order-modal>
  <notes-modal :stages="stages" :sources="sources" ref="notesModal" @updated="leads"></notes-modal>
  <business-card-scan-modal @scanned="onCardScanned"></business-card-scan-modal>
</template>
